import React from "react";
import useForm from "../../../../hooks/useForm";
import { otpVerification } from "../../../../services/authService";
import useMutation from "../../../../hooks/useMutation";
import { toast } from "react-toastify";
import OtpInput from "../../../form/OtpInput";
import { useNavigate } from "react-router-dom";
import Button from "../../../forms/Button";

const validation = {
  email: [
    {
      type: "email",
      required: true,
      message: "Enter valid Email",
    },
  ],
  otp: { required: true, message: "Please Enter Valid Otp" },
};

const OtpVerificationForm = () => {
  const { values, handleChange, handleSubmit, errors, setFieldsValue, resetField, formValidate } = useForm({ validationRules: validation });

  const navigate = useNavigate();

  const {
    mutate,
    error: signUpError,
    isPending: signUpPending,
    data: signUpData,
  } = useMutation({
    mutationFn: async (val) => {
      return await otpVerification({
        ...val,
      });
    },
    onSuccess: async (res) => {
      if (res?.status === 200) {
        navigate("/");
      } else {
        toast.warning(res?.message);
      }
    },
  });

  return (
    <form onSubmit={(event) => handleSubmit(event, mutate)}>
      <div className="space-y-4">
        <div className="relative">
          <OtpInput
            handleOtpChange={(val) =>
              handleChange({
                target: { value: val, name: "otp" },
              })
            }
            inputName="otp"
            {...formValidate(errors, "otp")}
          />
        </div>
        <div className="relative !mt-8">
          <Button buttonLabel={"Verify"} buttonClasses={"!rounded-md !pb-1 w-full"} buttonLabelClasses={"!text-xl font-medium"} buttonHasLink={true} buttonLink={"/reset-password"} />
        </div>
      </div>
    </form>
  );
};

export default OtpVerificationForm;
